import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';

import { User } from '@shared/models';

@Component({
  selector: 'mojo-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
})
export class UserCardComponent implements OnChanges {
  @Input() user: User;
  @Input() role: string;
  @Input() markedCandidateName: boolean;
  avatarShape = AvatarShapes.circle;
  avatarBackgroundSize = AvatarBackgroundSizes.cover;

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes && !!changes.user && !!changes.user.currentValue) {
      this.user = { ...this.user };
    }
  }

  getInitials(user: User): string {
    return !!user && !!user.firstName && !!user.lastName
      ? user.firstName[0] + user.lastName[0]
      : '';
  }
}
